"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failEvent = exports.completeEvent = exports.startEvent = void 0;
exports.startEvent = function (event) {
    return event + "Started";
};
exports.completeEvent = function (event) {
    return event + "Completed";
};
exports.failEvent = function (event) {
    return event + "Failed";
};
//# sourceMappingURL=EventMarker.js.map